import React from "react";
import { DarkModeLogo, LightModeLogo } from "./Logos";

export default function({ fill }: { fill: string }): JSX.Element {
  return fill === "#fff" ? <DarkModeLogo /> : <LightModeLogo />;
}
